import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import type CmdbLandingPageViewType from '@atlassian/jira-spa-apps-servicedesk-cmdb-landing-page/src/index.tsx';

const LazyAssetsLandingPage = lazyForPaint<typeof CmdbLandingPageViewType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-assets-landing-page" */ '@atlassian/jira-spa-apps-servicedesk-cmdb-landing-page'
		),
	),
);

// This component will redirect users from /jira/assets to /jira/assets/for-you
// ScreenRedirect triggers a redirect ui event so we don't need to fire a manual operational event
// We can remove this component once the feature is fully rolled out and frequency of the operational event is 0
const AssetsForYouRedirect = () => <ScreenRedirect to="/jira/assets/for-you" />;

/**
 * This component conditionally redirects to the "For You" page when the feature gate is enabled.
 * Otherwise, it renders the standard Assets landing page.
 *
 * @returns The Assets For You redirect or the Assets Landing page component.
 */
export const ConditionalAssetsPage = (): React.JSX.Element => {
	return fg('assets_for_you') ? (
		<AssetsForYouRedirect />
	) : (
		<LazyPage
			Page={LazyAssetsLandingPage}
			pageId="spa-apps/servicedesk/insight/cmdb-landing-page"
			shouldShowSpinner={false}
		/>
	);
};
